import { playerLoadLinearChannelThunkAction } from 'app-webtech-core/modules/player/actions/loadLinearChannel';
import { kind as playerKindSelector } from 'app-webtech-core/modules/player/selectors/';
import { currentlyPlayingSelector } from 'app-webtech-core/modules/podTracker/ads/selectors/';
import { guideChangeSelectedIndexThunkAction } from './changeSelectedIndex';
import { guideChangeCurrentPlayingIndexThunkAction } from './changeCurrentPlayingIndex';
import { guidePropertiesSelector } from '../selectors/properties';
import { isValidChannelIndex } from '../helpers/isValidChannelIndex';

export const guidePlayChannelAtIndexThunkAction = ({
  index: newIndex,
  setSelected = false,
  doNotTrack = false,
}) => async (dispatch, getState) => {
  const state = getState();
  const { list } = guidePropertiesSelector(state);

  const channelItem = list.find(isValidChannelIndex(newIndex));
  if (channelItem) {
    const { id } = channelItem;

    const currentlyPlayingKind = playerKindSelector(state);
    const currentlyPlaying = currentlyPlayingSelector(state, currentlyPlayingKind);
    dispatch(playerLoadLinearChannelThunkAction(id));
    dispatch(
      guideChangeCurrentPlayingIndexThunkAction({
        newIndex,
        channelId: id,
        currentlyPlaying,
        doNotTrack,
      }),
    );
    if (setSelected) {
      dispatch(guideChangeSelectedIndexThunkAction({ newIndex }));
    }
  }
};
